
export const findScorePointerPosition=(totalMarkScored)=>{
    // let angle = -55 + Math.floor(290 * (totalMarkScored / 109));
    let angle = -35 + Math.floor(250 * (totalMarkScored / 109));
    let styledAngle = `${angle}deg`
    return styledAngle;
}